if( ! document.getElementById('loginform') ) return;

const loginForm = document.getElementById('loginform');
const loginButton = document.getElementById('wp-submit');
const email = document.getElementById('user_login');
const password = document.getElementById('user_pass');

const modalCross = document.querySelector('.custom-message-modal-close');

function loginModal(message, title='Please wait') {
    const modalElement = document.querySelector('.custom-message-modal-overlay');
    const modalTitle = document.querySelector('.custom-message-modal-title');
    const modalBodyText = document.querySelector('.custom-message-modal-body');
    const modalFooter = document.querySelector('.custom-message-modal-footer');
    const modalTriggerBtn = document.querySelector('.open-modal-btn');
    if( modalElement ) modalElement.classList.add('processing');

    if( modalCross ) modalCross.style.display = 'none';
    if (modalTitle) modalTitle.innerHTML = title;
    if (modalFooter) modalFooter.innerHTML = '';

    if (modalBodyText) modalBodyText.innerHTML = '';
    if (modalBodyText) modalBodyText.innerHTML = message;

    if (modalTriggerBtn) modalTriggerBtn.click();
}

const validateEmail = (email) => {
    return String(email)
    .toLowerCase()
    .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

loginButton.addEventListener('click', function (event) {
    event.preventDefault();
    validateAndSubmit();
});

async function validateAndSubmit() {
    const errors = [];
    let loginProceed = true;

    document.querySelectorAll('.err').forEach(el => el.remove());

    if (!email?.value) {
        errors.push({
            message: 'Enter email address',
            attrElement: '#user_login',
            class: ['err']
        });
        loginProceed = false;
    } /*else if (!validateEmail(email.value)) {
        errors.push({
            message: 'Enter a valid email address',
            attrElement: '#user_login',
            class: ['err']
        });
        loginProceed = false;
    }*/

    if (!password?.value) {
        errors.push({
            message: 'Enter password',
            attrElement: '#user_pass',
            class: ['err']
        });
        loginProceed = false;
    }
    
    if( loginProceed ) {
        const params = new URLSearchParams({
            action: 'check_valid_login_credentials',
            email: email.value,
            password: password.value,
            email_verify_nonce: ajax_callback_data.ajax_nonce
        });

        loginModal('Verifying login credentials...');

        try {
            const response = await fetch(ajax_callback_data.ajax_url, {
                method: 'POST',
                body: params,
                headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            const result = await response.json();
            
            if (result.success) {
                loginModal('Logging in, please wait...', 'Confirmation');

            } else {
                let attrEl = result.data.attrEl;
                let messageEl = result.data.message;
                errors.push({
                    message: messageEl,
                    attrElement: attrEl,
                    class: ['err', 'invalid-credentials']
                });
                if( modalCross ) modalCross.click();
            }
        } catch (e) {
            console.error('AJAX Error:', e);
            errors.push({
                message: 'Unable to verify email',
                attrElement: '#user_login',
                class: ['err', 'invalid-credentials']
            });
            if( modalCross ) modalCross.click();
        }
            
    }

    if (errors.length > 0) {
        errors.forEach(error => {
            const errorDiv = document.querySelector('.login-username');
            if (!errorDiv) return;

            const createElement = document.createElement('div');
            createElement.classList.add(...error.class);
            createElement.textContent = error.message;

            errorDiv.before(createElement);
        });
        return;
    }

    loginForm.submit();
}